import {
  Collapse,
  Box,
  Link as MUILink,
  Grid,
  makeStyles,
} from "@material-ui/core";
import * as React from "react";

import { CoverUpload, FormSettingsRow, themeVariables } from "../../MUI";
import { tl } from "../../../../utils";
import { SvgIcon } from "../../../../components";


interface IProps {
  expanded?: boolean;
  courseCaption: string;
  setCourseCaption: any;
  courseCaptionMobile: string;
  setCourseCaptionMobile: any;
  errorCourseCaption?: 'tooBig' | 'tooSmall';
  errorCourseCaptionMobile?: 'tooBig' | 'tooSmall';
  setIsError?: any;
  onDelete: () => void;
  onDeleteMobile: () => void;
  courseId?: string | number;
  groupId?: string | number;

}

export const CourseCaption = ({
  expanded = false,
  courseId,
  groupId,
  courseCaption,
  setCourseCaption,
  courseCaptionMobile,
  setCourseCaptionMobile,
  errorCourseCaption,
  errorCourseCaptionMobile,
  onDelete,
  onDeleteMobile,
}: IProps) => {
  const [collapsed, setCollapsed] = React.useState(true);
  
  React.useEffect(() => {
    if (!!courseCaption || !!courseCaptionMobile || expanded) {
      setCollapsed(false);
    }
  }, [courseCaption, courseCaptionMobile]);

  React.useEffect(() => {
    if (expanded) {
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 500);
    }
  }, [expanded]);

  const classes = makeStyles({
    imgCaption: {
      paddingTop: themeVariables.spacing,
      fontSize: "13px",
      lineHeight: "18px",
    },
  })();

  return (
    <>
      <FormSettingsRow nolabel>
        <Box
          pt={2.5}
          pb={!collapsed ? 2.5 : 0}
          ml={-2.5}
          mr={-9}
          borderTop={themeVariables.border}
          borderBottom={!collapsed ? themeVariables.border : null}
        >
          <MUILink
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          >
            <Grid container alignItems="center" justifyContent="center">
              <Grid item>{tl("Дополнительные настройки (Обложка курса)")}</Grid>
              <Grid item>
                <Box marginLeft="4px" paddingTop="2px">
                  <SvgIcon type={`collapse ${!collapsed ? "active" : ""}`} />
                </Box>
              </Grid>
            </Grid>
          </MUILink>
        </Box>
      </FormSettingsRow>
      <Collapse in={!collapsed}>
        <FormSettingsRow
          label={tl("Обложка для ПК:")}
          smallLabel
          hint={tl(
            "Обложка украшает внешний вид курса. Она отображается на странице списка уроков и контактов автора после основной шапки сайта."
          )}
          hintAlign="flex-start"
        >
          <CoverUpload
            className="courseCaption"
            onChange={setCourseCaption}
            icon={courseCaption ? `/media/400/${window.btoa(courseCaption)}` : ""}
            useSystem={false}
            courseId={courseId}
            groupId={groupId}
            noCropping
            onDelete={(evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              onDelete()
            }}
          />
          <Box
            className={classes.imgCaption}
            color={themeVariables.palette.grey[600]}
          >
            {tl("Рекомендовано: 2280×400, max: 2280×600, min: 2280х172.")}
          </Box>
          <Collapse in={!!errorCourseCaption}>
            <Box
              className={classes.imgCaption}
              color={themeVariables.palette.error.main}
            >
              {
                errorCourseCaption === "tooBig"
                  ? tl("Загрузите картинку с разрешением не больше 2280х600.")
                  : tl("Загрузите картинку с разрешением не меньше 2280х172.")
              }
            </Box>
          </Collapse>
        </FormSettingsRow>
        <FormSettingsRow
          label={tl("Обложка для смартфона (необязательно):")}
          smallLabel
        >
          <CoverUpload
            className="courseCaptionMobile"
            onChange={setCourseCaptionMobile}
            courseId={courseId}
            groupId={groupId}
            icon={courseCaptionMobile ? `/media/400/${window.btoa(courseCaptionMobile)}` : ""}
            noCropping
            useSystem={false}
            onDelete={(evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              onDeleteMobile();
            }}
          />
          <Box
            className={classes.imgCaption}
            color={themeVariables.palette.grey[600]}
          >
            {tl("Рекомендовано: 1300×520, max: 1300×780, min: 1300х224.")}
          </Box>
          <Collapse in={!!errorCourseCaptionMobile}>
            <Box
              className={classes.imgCaption}
              color={themeVariables.palette.error.main}
            >
              {
                errorCourseCaptionMobile === "tooBig"
                  ? tl("Загрузите картинку с разрешением не больше 1300x780.")
                  : tl("Загрузите картинку с разрешением не меньше 1300х224.")
              }
            </Box>
          </Collapse>
        </FormSettingsRow>
      </Collapse>
    </>
  );
};
